import { parseUseCase } from "./use-case";

const key = "deepface-use-case-draft";
const maxAge = 60 * 60 * 1000;
type Draft = { email: string; useCase: string; expires: number };

// Only the explicitly submitted summary survives the email round trip, in this tab.
export function saveUseCaseDraft(email: string, useCase: string): boolean {
  try {
    if (!useCase.trim()) { sessionStorage.removeItem(key); return true; }
    sessionStorage.setItem(key, JSON.stringify({ email: email.trim().toLowerCase(), useCase: useCase.trim(), expires: Date.now() + maxAge }));
    return true;
  } catch { return false; }
}
export function readUseCaseDraft(): Draft | null {
  try {
    const raw = sessionStorage.getItem(key);
    if (!raw) return null;
    const draft = JSON.parse(raw) as Draft;
    if (typeof draft.email !== "string" || typeof draft.expires !== "number" || draft.expires < Date.now() || !parseUseCase({ use_case: draft.useCase })?.useCase) {
      sessionStorage.removeItem(key); return null;
    }
    return draft;
  } catch { return null; }
}
export function clearUseCaseDraft() { try { sessionStorage.removeItem(key); } catch { /* Storage may be unavailable. */ } }
